
const login = {
  namespaced: true,
  state: {
    step: 1,
    settleData: {
      id: null,
      accountLabel: '', // 银行卡名称
      accountType: '', // 账户类型 1一般贸易类 2电商类
      accountBalance: '', // 提现余额
      accNo: '', // 结汇账户
      actualAmount: '', // 实际结汇金额
      amount: '', // 申请结汇金额
      seAccountInfoId: '', // 银行卡id
      bankCard: '', // 结汇到银行卡卡号
      currencyId: '', // 账户币种
      transferCharge: '', // 手续费
      orderTotalNoney: '', // 订单总额
      referenceRate: '', // 参考费率
      // predictAmount: '', // 预计到账人民币
      // 资金用途 remark => 1工资 2赡家款 3一般贸易货款 4未纳入海关统计的网络平台销售贷款 5境外留学生生活费用

      remark: '4', // 资金用途
      recvNos: [], // 汇入订单列表
      // checkedStrs: '', // 汇入订单列表字符串
      settlementBalance: '', // 可结汇额度
      orderIdList: [] // 汇付天下订单信息列表
    }
  },
  mutations: {
    SET_ALL (state, data) {
      for (const k in data) {
        state[k] = data[k]
      }
    },
    SET_SETTTLEDATA (state, data) {
      for (const k in data) {
        state.settleData[k] = data[k]
      }
    }
  },
  actions: {
  }
}

export default login
